import { decodeToken, isExpired } from "react-jwt";

export function getTokenInfo(token?: string): any | null {
  if (!token) return null;
  try {
    return decodeToken(token);
  } catch (error) {
    console.error("Error decoding token:", error);
    return null;
  }
}

export function checkTokenExpired(token?: string): boolean {
  if (!token) return true;
  return isExpired(token);
}

function getTokenClaim(token: string | undefined, claim: string): any {
  const tokenInfo = getTokenInfo(token);
  return tokenInfo ? tokenInfo[claim] : null;
}

export function getUserIdFromToken(token?: string): string | null {
  return getTokenClaim(token, "sub");
}

export function getAllTokenClaims(token?: string): Record<string, any> {
  return getTokenInfo(token) || {};
}
